<template>
  <div id="setting-screen" class="mt-0">
    <v-tabs
      :value="currentTabIndex"
      @change="changeTab"
      background-color="transparent"
      class="bg-white mb-4 rounded"
    >
      <v-tab
        v-for="tabItem in tabs"
        :tabindex="tabItem.index"
        :key="tabItem.index"
        @click="loadRoute(tabItem.routeName)"
        >{{ tabItem.label }}</v-tab
      >
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      currentTabIndex: null,
      tabs: [
        {
          index: 0,
          label: this.$t("_SALE_PACKAGE.SALE_PACKAGE"),
          routeName: "listOfSalePackages",
          roles: ["SALE_PACKAGE_MANAGEMENT"],
        },
        {
          index: 1,
          label: this.$t("_SALE_PACKAGE.RATE_CATEGORY"),
          routeName: "rateCategorys",
          roles: ["SALE_PACKAGE_MANAGEMENT"],
        },
      ],
    };
  },
  created() {
    this.tabs = this.fnItemTab(this.tabs);
    switch (this.$route.name) {
      case "editSalePackages":
      case "listOfSalePackages":
        this.currentTabIndex = 0;
        break;
      case "rateCategoryDetail":
      case "rateCategorys":
        this.currentTabIndex = 1;
        break;
    }
  },
  watch: {
    $route(value) {
      switch (this.$route.name) {
        case "editSalePackages":
        case "listOfSalePackages":
          this.currentTabIndex = 0;
          break;
        case "rateCategoryDetail":
        case "rateCategorys":
          this.currentTabIndex = 1;
          break;
      }
    },
  },
  methods: {
    changeTab(tabIndex) {
      this.currentTabIndex = tabIndex;
    },
    loadRoute(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>
